// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OUmg","col":"styles_col__iq1es"};